import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICompany } from 'identity-webapi-client';
import { Router } from '@angular/router';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { Role } from 'src/app/shared/models/role.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ranges-list',
  templateUrl: './ranges-list.component.html',
  styleUrls: ['./ranges-list.component.less']
})
export class RangesListComponent implements OnInit, OnDestroy {
  isDarkMode: boolean = false;
  company: ICompany | undefined;
  admin = false;

  private _loading = false;
  public get loading(): boolean { return this._loading; }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private stateService: StateService) {}

  ngOnInit(): void {
    this.admin = this.authService.hasRole(Role.SituSystemsDeveloper) || this.authService.hasRole(Role.SituSystemsAdmin);
    this._subscriptions.push(this.stateService.state$.subscribe(state => {
        this.isDarkMode = state.useDarkTheme;
        this.company = state.company ?? undefined;
    }));
  }

  ngOnDestroy(): void {
    if (this._subscriptions) {
      for (let sub of this._subscriptions) {
        sub.unsubscribe();
      }
      this._subscriptions = [];
    }
  }

  newRange() {
    this.router.navigate(['/products/ranges/add']);
  }
}
